import { render } from "./Datatable.vue?vue&type=template&id=242b9fd2&scoped=true"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=242b9fd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242b9fd2"]])

export default __exports__